var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLockGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.33317H11.3334V3.99984C11.3334 2.15984 9.84002 0.666504 8.00002 0.666504C6.16002 0.666504 4.66669 2.15984 4.66669 3.99984V5.33317H4.00002C3.26669 5.33317 2.66669 5.93317 2.66669 6.6665V13.3332C2.66669 14.0665 3.26669 14.6665 4.00002 14.6665H12C12.7333 14.6665 13.3333 14.0665 13.3333 13.3332V6.6665C13.3333 5.93317 12.7333 5.33317 12 5.33317ZM8.00002 11.3332C7.26669 11.3332 6.66669 10.7332 6.66669 9.99984C6.66669 9.2665 7.26669 8.6665 8.00002 8.6665C8.73335 8.6665 9.33335 9.2665 9.33335 9.99984C9.33335 10.7332 8.73335 11.3332 8.00002 11.3332ZM10.0667 5.33317H5.93335V3.99984C5.93335 2.85984 6.86002 1.93317 8.00002 1.93317C9.14002 1.93317 10.0667 2.85984 10.0667 3.99984V5.33317Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLockGray);
export default __webpack_public_path__ + "static/media/icon_lock_gray.e1cf91d801eb034a1d5ab3f88759ab72.svg";
export { ForwardRef as ReactComponent };